
import { Component, inject } from '@angular/core';
import { FormsModule } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef
} from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";

export interface FollowUpDialogData {
  addressId: string,
  visitId: string,
}

@Component({
    selector: 'follow-up-dialog',
    imports: [
    MatDialogClose,
    FormsModule,
    MatIcon
],
    templateUrl: './follow-up-dialog.component.html',
    styleUrl: './follow-up-dialog.component.css'
})
export class FollowUpDialogComponent {
  dialogRef = inject<MatDialogRef<FollowUpDialogComponent>>(MatDialogRef);
  data = inject<FollowUpDialogData>(MAT_DIALOG_DATA);

  message: string = '';
}
